'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _relativeBarrier = require('./relativeBarrier');

var _relativeBarrier2 = _interopRequireDefault(_relativeBarrier);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (contract, lastTickQuote) {
    return contract.barrier ? (0, _relativeBarrier2.default)(contract, lastTickQuote) : +contract.entry_spot || lastTickQuote;
};


//////////////////
// WEBPACK FOOTER
// ./~/binary-utils/lib/barrier/callPutBarrier.js
// module id = 51
// module chunks = 0